import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Container, Typography } from '@mui/material';
import Hero from '../../sections/Hero';

const TermsOfServicePage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service</title>
        <meta
          name="description"
          content="JBR Delivery LLC terms of service. Review our terms and conditions for using our services."
        />
      </Helmet>

      <Hero 
        title="Terms of Service"
        subtitle="Our terms and conditions for providing services"
        backgroundImage="/assets/images/legal-bg.jpg"
        showPhone={false}
      />

      <Box component="section" py={8}>
        <Container maxWidth="md">
          <Typography variant="h2" component="h2" gutterBottom>
            Terms of Service
          </Typography>
          
          <Typography variant="body1" paragraph sx={{ mb: 4 }}>
            Last Updated: March 15, 2025
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1" paragraph>
            By accessing or using the services provided by JBR Delivery LLC ("we," "our," or "us"), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            2. Service Description
          </Typography>
          <Typography variant="body1" paragraph>
            JBR Delivery LLC provides delivery, junk removal, and moving services in Northeast Wisconsin. Our services may include, but are not limited to, furniture delivery, appliance delivery, junk removal, residential moving, and commercial moving.
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            3. Scheduling and Cancellations
          </Typography>
          <Typography variant="body1" paragraph>
            Services are scheduled based on availability. We make every effort to arrive within the scheduled time frame, but unforeseen circumstances may cause delays. 
          </Typography>
          <Typography variant="body1" paragraph>
            If you need to cancel a scheduled service, please notify us at least 24 hours in advance. Cancellations made less than 24 hours before the scheduled service may incur a cancellation fee.
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            4. Pricing and Payment
          </Typography>
          <Typography variant="body1" paragraph>
            Pricing is determined based on the specific service, distance, size, weight, and other relevant factors. A quote provided before service is an estimate and may be subject to change based on actual service conditions.
          </Typography>
          <Typography variant="body1" paragraph>
            Payment is due upon completion of service unless otherwise agreed upon in advance. We accept cash, checks, and major credit cards.
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            5. Service Limitations
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to refuse service if we determine that the requested task poses a safety risk, violates any laws or regulations, or is otherwise beyond our service capabilities.
          </Typography>
          <Typography variant="body1" paragraph>
            For junk removal services, we do not accept hazardous materials, including but not limited to chemicals, paints, oils, and certain electronics.
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            6. Liability
          </Typography>
          <Typography variant="body1" paragraph>
            While we take all reasonable care in providing our services, JBR Delivery LLC is not liable for any damage to property that occurs during normal service operations, unless such damage is a direct result of our negligence.
          </Typography>
          <Typography variant="body1" paragraph>
            We maintain appropriate insurance coverage for our services. If damage occurs due to our negligence, please notify us immediately so we can address the issue promptly.
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            7. Dispute Resolution
          </Typography>
          <Typography variant="body1" paragraph>
            Any disputes arising from our services shall be resolved through good-faith negotiation. If negotiation fails to resolve the dispute, it shall be resolved through arbitration in accordance with the laws of the State of Wisconsin.
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            8. Modifications to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to modify these Terms of Service at any time. Any changes will be effective immediately upon posting on our website. Your continued use of our services after such modifications constitutes your acceptance of the updated terms.
          </Typography>
          
          <Typography variant="h5" component="h3" gutterBottom sx={{ mt: 4 }}>
            9. Contact Information
          </Typography>
          <Typography variant="body1" paragraph>
            If you have questions about these Terms of Service, please contact us at jbrdeliveryllc@gmail.com or (920) 255-8952.
          </Typography>
        </Container>
      </Box>
    </>
  );
};

export default TermsOfServicePage;
